const jiraEndpoints = {
  requestTypes: '/jira/request-types',
  components: '/jira/components',
  request: '/jira/request'
}

export default jiraEndpoints
